import {extend} from 'vega-util';

export default function() {
  var args = [].slice.call(arguments);
  args.unshift({});
  return extend.apply(null, args);
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/vega-parser/src/parsers/expression/merge.js
// module id = 885
// module chunks = 0